enum GitErrorCode {
	HealthcheckFailed = "HealthcheckFailed",
	RemoteRepositoryNotFoundError = "RemoteRepositoryNotFoundError",
	LocalRepositoryNotFoundError = "LocalRepositoryNotFoundError",
	ContentTooLargeError = "ContentTooLargeError",
	NotAuthorizedError = "NotAuthorizedError",
	CurrentBranchNotFoundError = "CurrentBranchNotFoundError",
	NetworkConntectionError = "NetworkConntectionError",
	NetworkTimeoutError = "NetworkTimeoutError",
	MergeNotSupportedError = "MergeNotSupportedError",
	CantGetConflictedFiles = "CantGetConflictedFiles",
	CheckoutConflictError = "CheckoutConflictError",
	DeleteCurrentBranch = "DeleteCurrentBranch",
	MergeConflictError = "MergeConflictError",
	AlreadyExistsError = "AlreadyExistsError",
	WorkingDirNotEmpty = "WorkingDirNotEmpty",
	PushRejectedError = "PushRejectedError",
	PushDeclinedByRemoteError = "PushDeclinedByRemoteError",
	NotFoundError = "NotFoundError",
	GitPushError = "GitPushError",
	CloneError = "CloneError",
	MergeError = "MergeError",
	HttpError = "HttpError",
	FileNotFoundError = "FileNotFoundError",
	CancelledOperation = "CancelledOperation",
	NotEnoughDiskSpace = "NotEnoughDiskSpace",
	BranchCheckedOutElsewhere = "BranchCheckedOutElsewhere",
	InvalidPathError = "InvalidPathError",
}

export default GitErrorCode;
